import React from 'react';
import { connect } from 'react-redux';
import { Menu, Icon } from 'antd';

import { selectElements, selectedDirectory } from '../../actions/selectedElement';
import { backForwardDirectory } from '../../actions/backForward';
import { setBrowserData } from '../../actions';
import { toastInfo, toastError } from '../../utils/toastr';
import setDataInFileBrowser from '../../helpers/setDataInFileBrowser';

import './navigationPanel.scss';

const NavigationPanel = ({
	selectElements,
	selectedDirectory,
	backForwardDirectory,
	browserData,
	siteId,
	setData,
	sites,
	directory,
	backForward
}) => {
	const handleClickSelect = () => {
		selectElements(
			browserData.map((elem) => {
				return {
					name: elem.label,
					isFolder: JSON.parse(elem.value).isFolder
				};
			})
		);
	};

	const handleClickUnselect = () => {
		selectElements([]);
	};

	const handleClickHome = () => {
		if (!siteId) {
			toastError('Please select a site!');
			return;
		}
		const params = {
			routeParams: {
				route: 'dir'
			},
			additionalQueryStringParams: {
				site_id: siteId
			}
		};

		setDataInFileBrowser(params, sites, setData, siteId);
		selectedDirectory('');
		backForwardDirectory({ back: [ ...backForward.back, '' ], forward: backForward.forward });
	};

	const handleClickReload = () => {
		if (!siteId) {
			toastError('Please select a site!');
			return;
		}
		const params = {
			routeParams: {
				route: 'dir'
			},
			additionalQueryStringParams: {
				site_id: siteId,
				directory
			}
		};

		setDataInFileBrowser(params, sites, setData, siteId);
	};

	const handleClickUp = () => {
		if (!siteId) {
			toastError('Please select a site!');
			return;
		}
		if (!directory) {
			toastInfo('This is a root directory.');
			return;
		}

		const directoryToArray = directory.split('/');

		const prevDirectory =
			directoryToArray.length === 1 ? '' : directoryToArray.splice(0, directoryToArray.length - 1).join('/');

		const params = {
			routeParams: {
				route: 'dir'
			},
			additionalQueryStringParams: {
				site_id: siteId,
				directory: prevDirectory
			}
		};

		setDataInFileBrowser(params, sites, setData, siteId);
		selectedDirectory(prevDirectory);
		backForwardDirectory({ back: [ ...backForward.back, prevDirectory ], forward: backForward.forward });
	};

	const handleClickBack = () => {
		if (backForward.back.length < 2) {
			return;
		}

		const back = backForward.back.slice(0, backForward.back.length - 1);
		const forward = backForward.back[backForward.back.length - 1];

		const params = {
			routeParams: {
				route: 'dir'
			},
			additionalQueryStringParams: {
				site_id: back[back.length - 1].siteId,
				directory: back[back.length - 1].directory
			}
		};

		setDataInFileBrowser(params, sites, setData, siteId);
		selectedDirectory(back[back.length - 1].directory);
		backForwardDirectory({ back, forward: [ ...backForward.forward, forward ] });
	};

	const handleClickForward = () => {
		if (backForward.forward.length <= 0) {
			return;
		}

		const back = backForward.forward[backForward.forward.length - 1];
		const forward = backForward.forward.slice(0, backForward.forward.length - 1);

		const params = {
			routeParams: {
				route: 'dir'
			},
			additionalQueryStringParams: {
				site_id: backForward.forward[backForward.forward.length - 1].siteId,
				directory: backForward.forward[backForward.forward.length - 1].directory
			}
		};

		setDataInFileBrowser(params, sites, setData, siteId);
		selectedDirectory(backForward.forward[backForward.forward.length - 1].directory);
		backForwardDirectory({ back: [ ...backForward.back, back ], forward });
	};

	const itemsArray = [
		{
			name: 'Home',
			icon: 'home',
			handleClick: handleClickHome
		},
		{
			name: 'Up One Level',
			icon: 'arrow-up',
			handleClick: handleClickUp
		},
		{
			name: 'Back',
			icon: 'step-backward',
			handleClick: handleClickBack
		},
		{
			name: 'Forward',
			icon: 'step-forward',
			handleClick: handleClickForward
		},
		{
			name: 'Reload',
			icon: 'reload',
			handleClick: handleClickReload
		},
		{
			name: 'Select All',
			icon: 'check-square',
			handleClick: handleClickSelect
		},
		{
			name: 'Unselect All',
			icon: 'close-square',
			handleClick: handleClickUnselect
		}
	];

	let navigationPanelItems = [];

	itemsArray.forEach((element, i) => {
		navigationPanelItems.push(
			<Menu.Item key={i} onClick={element.handleClick}>
				<Icon type={element.icon} />
				{element.name}
			</Menu.Item>
		);
	});

	return (
		<Menu mode={'horizontal'} selectable={false} theme={'light'} className="navigation-panel">
			{navigationPanelItems}
		</Menu>
	);
};

const mapStateToProps = (state) => {
	return {
		browserData: state.files.browserData,
		siteId: state.selectedElement.siteId,
		sites: state.sites.sitesFromServer,
		directory: state.selectedElement.directory,
		backForward: state.navigation.backForward
	};
};

const mapDispatchToProps = (dispatch) => ({
	selectElements: (data) => dispatch(selectElements(data)),
	setData: (data) => dispatch(setBrowserData(data)),
	selectedDirectory: (data) => dispatch(selectedDirectory(data)),
	backForwardDirectory: (data) => dispatch(backForwardDirectory(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(NavigationPanel);
